import Form from 'react-bootstrap/Form';

function FormLabel(props) {
  return <Form.Label className="font-monospace mt-3 mb-1" {...props}>{props.children}</Form.Label>
}

export default FormLabel;
